"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParliamentHall = void 0;
const Tags_1 = require("../Tags");
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const Resources_1 = require("../../Resources");
const CardRequirements_1 = require("../CardRequirements");
const CardRenderer_1 = require("../render/CardRenderer");
const constants_1 = require("../../constants");
const TurmoilHandler_1 = require("../../turmoil/TurmoilHandler");
class ParliamentHall extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.PARLIAMENT_HALL,
            tags: [Tags_1.Tags.BUILDING],
            cost: 8,
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.party(PartyName_1.PartyName.MARS)),
            metadata: {
                cardNumber: 'T08',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.production((pb) => {
                        pb.megacredits(1).slash().building(3).played;
                    });
                }),
                description: 'Requires that Mars First are ruling or that you have 2 delegates there. Increase your M€ production 1 step for every 3 Building tags you have, including this.',
                victoryPoints: 1,
            },
        });
    }
    canPlay(player) {
        const turmoil = player.game.turmoil;
        if (turmoil !== undefined) {
            if (turmoil.parties.find((p) => p.name === PartyName_1.PartyName.MARS)) {
                return turmoil.canPlay(player, PartyName_1.PartyName.MARS);
            }
            Card_1.Card.setSocietyWarningText(this, PartyName_1.PartyName.MARS);
            return player.canAfford(player.getCardCost(this) + constants_1.SOCIETY_ADDITIONAL_CARD_COST);
        }
        return false;
    }
    produce(player) {
        const includeThis = !player.cardIsInEffect(this.name);
        const tagCount = player.getTagCount(Tags_1.Tags.BUILDING) + (includeThis ? 1 : 0);
        const amount = Math.floor(tagCount / 3);
        player.addProduction(Resources_1.Resources.MEGACREDITS, amount, { log: true });
    }
    play(player) {
        this.produce(player);
        TurmoilHandler_1.TurmoilHandler.handleSocietyPayment(player, PartyName_1.PartyName.MARS);
        return undefined;
    }
    getVictoryPoints() {
        return 1;
    }
}
exports.ParliamentHall = ParliamentHall;
//# sourceMappingURL=ParliamentHall.js.map